import { OfferPreview } from "@justhome/api-core";
import { useMemo } from "react";

const useGetOffersWithLowestMonthlyInstallment = (
  offers: OfferPreview[] | undefined,
): Set<string> => {
  return useMemo(() => {
    const lowestInstallment = offers
      ?.map((offer) => offer.monthlyInstallment as number)
      .filter((value) => value)
      .reduce((a, b) => Math.min(a, b), Number.MAX_SAFE_INTEGER);
    return new Set(
      offers
        ?.filter((offer) => offer.monthlyInstallment === lowestInstallment)
        .map((offer) => offer.id!),
    );
  }, [offers]);
};

export default useGetOffersWithLowestMonthlyInstallment;
